<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-estimates">
                <template slot="button-content">
                    <i class="cus-page-paste"></i>
                    Estimates
                </template>
                <div>
                    <b-dropdown-item @click="displayList('all')">
                        <i class="cus-page-paste"></i>
                        View All Estimates
                    </b-dropdown-item>
                    <b-dropdown-item @click="displayList('approved')">
                        <i class="cus-page-paste"></i>
                        View Approved
                    </b-dropdown-item>
                    <b-dropdown-item @click="displayList('converted')">
                        <i class="cus-page-paste"></i>
                        View Converted
                    </b-dropdown-item>
                    <b-dropdown-item @click="displayList('open')">
                        <i class="cus-page-paste"></i>
                        View Open
                    </b-dropdown-item>
                </div>

                <li
                    v-if="_hasAccess('billing.estimate.create')"
                    class="dropdown-divider"
                ></li>

                <b-dropdown-item
                    v-if="_hasAccess('billing.estimate.create')"
                    @click="openEstimateModal"
                >
                    <i class="cus-add"></i>
                    New Estimate
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <estimate-list ref="estimeList" :key="keyview" :status="status" />
        </b-card-text>
    </b-tab>
</template>

<script>
import EstimateList from "@/components/billing-estimate/estimate-list";

const ESTIMATESTATUS = {
    all: 0,
    approved: 1,
    converted: 2,
    open: 3
};

export default {
    components: {
        EstimateList
    },
    data() {
        return {
            keyview: 0,
            status: ESTIMATESTATUS.all
        };
    },
    methods: {
        displayList(status) {
            this.keyview += 1;
            this.status = ESTIMATESTATUS[status];
        },
        openEstimateModal() {
            this.$emit("open-new-estimate");
        }
    }
};
</script>
